{
  "account.backToSignIn": "Back to sign-in",
  "account.birthDate": "Date of birth",
  "account.birthDateHint": "Below the age required in your country, a festival is not attended alone.",
  "account.childProfile": "Child profile",
  "account.country": "Country",
  "account.countryOption": "Country: {{name}}",
  "account.day": "Day",
  "account.dayShort": "DD",
  "account.delete": "Delete my account",
  "account.deleteConfirm": "Delete for good",
  "account.deleteExplain": "Your account, your groups, your shared locations and your surveys will be erased, along with any linked child profiles. This cannot be undone. The lineup, your favourites and your markers stay on this phone.",
  "account.deletePasswordHint": "Enter your password to confirm.",
  "account.deleted": "Your account has been deleted.",
  "account.displayName": "Display name",
  "account.email": "Email address",
  "account.forgot": "Forgot your password?",
  "account.invalidCredentials": "Incorrect address or password.",
  "account.invitationCode": "Invitation code",
  "account.invitationHint": "Sign-up is not open: an account is created with a code given to you by someone.",
  "account.invitationInvalid": "This invitation code is not valid.",
  "account.invitationScanned": "Invitation recognised: fill in the form.",
  "account.month": "Month",
  "account.monthShort": "MM",
  "account.newPassword": "New password",
  "account.open": "Account",
  "account.password": "Password",
  "account.passwordHint": "Twelve characters minimum.",
  "account.registrationFailed": "Sign-up could not be completed. Check the details you entered.",
  "account.resetCode": "Code received",
  "account.resetConfirm": "Change the password",
  "account.resetDone": "Password changed. Sign in with the new one.",
  "account.resetExplain": "Enter your account's address: we will send a six-digit code to it.",
  "account.resetInvalid": "This code is not valid, or it has expired. Ask for a new one.",
  "account.resetSend": "Send me a code",
  "account.resetSent": "If an account uses this address, a code has just been sent to it. It is valid for 15 minutes.",
  "account.signIn": "Sign in",
  "account.signOut": "Sign out",
  "account.signUp": "Create an account",
  "account.signedInAs": "Signed in as {{name}}",
  "account.title": "My account",
  "account.toggleToSignIn": "I already have an account",
  "account.toggleToSignUp": "I do not have an account yet",
  "account.tooMany": "Too many attempts. Try again in a few minutes.",
  "account.tooYoung": "The account must be created by an adult, who can then attach a child profile to it.",
  "account.unreachable": "Server unreachable. Try again once the network is back.",
  "account.year": "Year",
  "account.yearShort": "YYYY",
  "aerial.download": "Download aerial imagery",
  "aerial.downloading": "Downloading…",
  "aerial.explain": "A drone view of the site. It takes {{size}} MB on your phone and downloads only once.",
  "aerial.failed": "Download failed. Try again on Wi-Fi.",
  "aerial.ready": "Aerial imagery available offline",
  "aerial.remove": "Delete aerial imagery",
  "aerial.title": "Aerial imagery",
  "aerial.wifiHint": "Best done before you arrive, on Wi-Fi.",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.retry": "Retry",
  "common.search": "Search",
  "crew.apiUnavailable": "Crew unavailable: no server configured",
  "crew.background.active": "Your location is sent even with the phone in your pocket, about once a minute while you move.",
  "crew.background.allow": "Allow location all the time",
  "crew.background.foregroundOnly": "Your friends only see you while the app is open.",
  "crew.background.notificationBody": "Until {{time}}. Open the app to stop.",
  "crew.background.notificationTitle": "Sharing your location with {{crew}}",
  "crew.codeLabel": "Crew code",
  "crew.create": "Create a crew",
  "crew.error.festival": "This festival is not on the server yet, so a group cannot be created for it.",
  "crew.error.notFound": "No group has this code. Check it with the person who created the group.",
  "crew.error.notMember": "You are no longer in this group, or it has expired.",
  "crew.error.refused": "The server refused the request. Try again later.",
  "crew.error.session": "Your session has expired. Sign in again.",
  "crew.error.tooMany": "Too many attempts. Try again in a few minutes.",
  "crew.join": "Join with a code",
  "crew.lastSeen": "Seen {{minutes}} min ago",
  "crew.lastSeenDays": "Seen {{days}} d ago",
  "crew.lastSeenHours": "Seen {{hours}} h ago",
  "crew.nameLabel": "Group name",
  "crew.near": "Near {{place}}",
  "crew.needAccount": "An account is needed to join a crew",
  "crew.noCrew": "No crew yet",
  "crew.noPosition": "Not sharing their location",
  "crew.offline": "Offline — last known information",
  "crew.positionStale": "Old location",
  "crew.rallyNeedPosition": "Turn on location to see where it is",
  "crew.rallyOnMap": "Group meeting point",
  "crew.rallySetAt": "Set at {{time}}",
  "crew.section.members": "The group",
  "crew.section.sharing": "My location",
  "crew.setRally": "Set a meeting point here",
  "crew.shareCode": "Have this code scanned, or read it out",
  "crew.shareOff": "Location sharing off",
  "crew.sharing.APPROXIMATE": "Approximate area",
  "crew.sharing.OFF": "Don't share",
  "crew.sharing.PRECISE": "Precise location",
  "crew.sharingFor": "Share for {{hours}} h",
  "crew.sharingUntil": "Sharing until {{time}}",
  "crew.showOnMap": "Show on the map",
  "crew.title": "My crew",
  "crew.you": "That's you",
  "diary.empty": "No shows marked yet",
  "diary.markSeen": "I was there",
  "diary.notYet": "Not started yet",
  "diary.photosCount": "{{count}} photo(s) taken during the festival",
  "diary.photosDenied": "Photo access denied",
  "diary.photosExplain": "Photos stay on your phone: nothing is copied or uploaded.",
  "diary.photosNone": "No photos found for this period",
  "diary.photosPermission": "Allow access to photos",
  "diary.photosTitle": "Photos from this festival",
  "diary.stats": "{{performances}} show(s) · {{artists}} artist(s) · {{days}} day(s)",
  "diary.unmarkSeen": "Remove from diary",
  "festival.checkedOn": "checked on {{date}}",
  "festival.reportHint": "Spotted a mistake? Tap this banner, or long-press a set or a place.",
  "festival.source": "Lineup taken from: {{source}}",
  "festival.unofficial": "Unofficial page: information not checked by the organiser.",
  "keyring.add": "Add a festival",
  "keyring.already": "Already in your festivals",
  "keyring.change": "Switch festival",
  "keyring.current": "Currently open",
  "keyring.empty": "No festival added yet.",
  "keyring.noResult": "No festival found.",
  "keyring.offline": "Search needs a network. Festivals already added remain available.",
  "keyring.pinFailed": "Your phone could not add the icon.",
  "keyring.pinHint": "An icon for this festival that opens the app straight on it.",
  "keyring.pinShortcut": "Add to home screen",
  "keyring.remove": "Remove",
  "keyring.removed": "Festival removed. Its offline content has been deleted.",
  "keyring.search": "Festival or town name",
  "keyring.searchHint": "You can also scan your ticket: the festival adds itself.",
  "keyring.title": "My festivals",
  "lineup.all": "Full line-up",
  "lineup.cancelled": "Cancelled",
  "lineup.conflict": "Overlaps another of your favourites",
  "lineup.conflictLine": "{{first}} and {{second}} overlap by {{minutes}} min",
  "lineup.conflictsTitle": "{{count}} clash(es) between your favourites",
  "lineup.delayed": "Delayed",
  "lineup.favorite": "Add to my favourites",
  "lineup.favoritesOnly": "My favourites",
  "lineup.noPerformances": "No shows scheduled",
  "lineup.reminderBody": "{{artist}} in {{minutes}} min · {{stage}}",
  "lineup.reminderTitle": "Starting soon",
  "lineup.remindersPlanned": "{{count}} reminder(s) set",
  "lineup.remindersUnavailable": "Reminders unavailable — notifications denied",
  "lineup.removeFavorite": "Remove from favourites",
  "lineup.title": "Line-up",
  "location.denied": "Location denied — the map still works",
  "location.granted": "Location on",
  "mail.reset.body": "Hello {{name}},\n\nHere is your code to choose a new Festipal password:\n\n{{code}}\n\nIt is valid for {{minutes}} minutes. If you did not ask for it, ignore this message: your password stays the same.\n\nFestipal",
  "mail.reset.subject": "Your Festipal code: {{code}}",
  "map.bearing.east": "to the east",
  "map.bearing.north": "to the north",
  "map.bearing.northeast": "to the northeast",
  "map.bearing.northwest": "to the northwest",
  "map.bearing.south": "to the south",
  "map.bearing.southeast": "to the southeast",
  "map.bearing.southwest": "to the southwest",
  "map.bearing.west": "to the west",
  "map.closeDetail": "Close",
  "map.distanceMeters": "{{distance}} m away",
  "map.listView": "View places as a list",
  "map.loadError": "The map could not be loaded",
  "map.loading": "Preparing the map…",
  "map.locateMe": "Locate me",
  "map.offlineBadge": "Offline map",
  "map.offlineNotice": "Map available offline",
  "map.tapHint": "Tap a point on the map to see what it is.",
  "map.title": "Site map",
  "marker.car": "My car",
  "marker.dropHere": "Drop a marker here",
  "marker.meeting": "Meeting point",
  "marker.needLocation": "Location needed to drop a marker",
  "marker.other": "Marker",
  "marker.remove": "Remove this marker",
  "marker.tent": "My tent",
  "me.account": "My account",
  "me.accountAnonymous": "No account yet",
  "me.diary": "My diary",
  "me.diaryCount": "{{count}} gig(s) seen",
  "me.festivals": "My festivals",
  "me.festivalsCount": "{{count}} festival(s) added",
  "me.scan": "Scan a code",
  "me.scanHint": "Ticket, invitation or crew",
  "me.survey": "Survey the site",
  "me.surveyHint": "Record the missing places",
  "me.title": "Me",
  "ping.age": "{{minutes}} min ago",
  "ping.cancel": "We found each other",
  "ping.channel": "Group calls",
  "ping.from": "{{name}}: “Join me!”",
  "ping.notificationBody": "Tap to see where.",
  "ping.notificationTitle": "{{name}}: “Join me!”",
  "ping.onMap": "Join {{name}}",
  "ping.send": "Join me: send my location",
  "ping.sendHint": "Your exact location goes to your group, for {{minutes}} min.",
  "ping.sent": "You called your group at {{time}}, until {{until}}.",
  "places.allCategories": "All",
  "places.awaitingLocation": "Getting your location…",
  "places.count": "{{count}} place(s)",
  "places.direction": "{{distance}} m {{bearing}} · {{minutes}} min walk",
  "places.fromHere": "Measure distances from this place",
  "places.locationUnavailable": "Location unavailable — places sorted by name",
  "places.noResult": "No place matches",
  "places.originDevice": "Distances from my location",
  "places.originManual": "Distances from {{place}}",
  "places.pickOrigin": "Pick a reference point from the list",
  "places.searchPlaceholder": "Search for a place",
  "places.title": "Places",
  "places.unverified": "Unverified",
  "places.useMyLocation": "Use my location",
  "poi.category.accessible": "Wheelchair access",
  "poi.category.bar": "Bar",
  "poi.category.charging": "Phone charging",
  "poi.category.entrance": "Entrance",
  "poi.category.exit": "Emergency exit",
  "poi.category.firstaid": "First aid post",
  "poi.category.food": "Food",
  "poi.category.info": "Information point",
  "poi.category.lockers": "Lockers",
  "poi.category.stage": "Stage",
  "poi.category.toilets": "Toilets",
  "poi.category.water": "Water point",
  "report.comment": "Tell us more if you like (optional)",
  "report.failed": "Not accepted. Try again later.",
  "report.festival": "The lineup or the map in general",
  "report.kind.CANCELLED": "Cancelled",
  "report.kind.GONE": "Doesn't exist (any more)",
  "report.kind.MISSING": "A set or a place is missing",
  "report.kind.OTHER": "Something else",
  "report.kind.WRONG_PLACE": "In the wrong place",
  "report.kind.WRONG_STAGE": "Wrong stage",
  "report.kind.WRONG_TIME": "Wrong time",
  "report.offline": "Offline: nothing was sent. Try again once you have a signal.",
  "report.openSource": "Open the source",
  "report.send": "Send",
  "report.sent": "Thanks! It has gone to whoever keeps this page.",
  "report.title": "Report a mistake",
  "report.tooMany": "Too many reports at once. Try again in a few minutes.",
  "safety.callEmergency": "Call emergency services",
  "safety.emergencyTitle": "Help and first aid",
  "safety.nearestFirstAid": "Nearest first aid post",
  "scan.close": "Close scanner",
  "scan.crewFound": "Crew recognised: {{code}}",
  "scan.festivalFound": "Festival recognised: {{slug}}",
  "scan.hint": "Scan your ticket or a crew code",
  "scan.invitationFound": "Invitation recognised",
  "scan.open": "Scan a code",
  "scan.permission": "Allow camera",
  "scan.permissionDenied": "Camera denied — enter the code by hand",
  "scan.privacy": "Only the festival identifier is read. Nothing else from the ticket is kept.",
  "scan.title": "Scan",
  "scan.unknown": "Code not recognised. If it comes from a ticketing service, find your festival in the list.",
  "shortcut.add": "Add",
  "shortcut.later": "Later",
  "shortcut.offer": "Add {{name}} to your home screen?",
  "survey.addPhoto": "Add a photo",
  "survey.category": "Type of place",
  "survey.comment": "Useful detail (optional)",
  "survey.intro": "Walk to the place you want to record, stand still while it measures, then name it.",
  "survey.measuring": "{{used}} readings kept · accuracy {{accuracy}} m",
  "survey.moderationNotice": "Every record is reviewed before it appears in the app.",
  "survey.name": "Name of the place",
  "survey.needAccount": "An account is required: a record is attributed to its author.",
  "survey.needLocation": "Location access is required to record a point.",
  "survey.open": "Survey",
  "survey.photoAttached": "Photo attached",
  "survey.photoRejected": "Photo discarded by the automatic filter. The record itself was sent.",
  "survey.queue": "My records",
  "survey.queueEmpty": "No records yet.",
  "survey.rejected": "{{count}} reading(s) discarded, too far from the others",
  "survey.removePhoto": "Remove the photo",
  "survey.save": "Save the record",
  "survey.send": "Send now",
  "survey.sendFailed": "Cannot send right now. The records stay on the device.",
  "survey.sending": "Sending…",
  "survey.start": "Start measuring",
  "survey.statusPending": "Waiting for network",
  "survey.statusRejected": "Record refused by the server.",
  "survey.statusSent": "Sent",
  "survey.stop": "Stop measuring",
  "survey.title": "Surveying",
  "survey.tooImprecise": "Accuracy is still insufficient. Move away from metal structures and wait.",
  "survey.waiting": "Waiting for GPS…",
  "tab.crew": "Crew",
  "tab.diary": "Diary",
  "tab.lineup": "Line-up",
  "tab.map": "Map",
  "tab.me": "Me",
  "tab.places": "Places"
}
